
import type { App } from "vue";
import { useIntersectionObserver } from "@vueuse/core";

export const lazyPlugin = {
    install: (app: App): void => {
        app.directive("img-lazy", {
            mounted(el: HTMLImageElement, binding) {
                lazyLoad(el, binding);
            },
            updated(el: HTMLImageElement, binding) {
                // 当图片 URL 变化时重新加载
                if (binding.value !== binding.oldValue) {
                    lazyLoad(el, binding);
                }
            }
        });
    }
};

// 提取公共的懒加载逻辑
function lazyLoad(el: HTMLImageElement, binding: any) {

    const { stop } = useIntersectionObserver(
        el,
        ([{ isIntersecting }]) => {
            if (isIntersecting) {
                el.src = binding.value;
                stop();
            }
        },
        {
            // 添加阈值，当元素进入视口时触发
            threshold: 0.1,
            // 添加根边距，提前加载
            rootMargin: "50px"
        }
    );
}
